class NewsfeedsStateService {
    /*@ngInject*/
    OutputMgrService:any;
    $http: any;
    $timeout: any;
    $q: any;
    $mdToast: any;
    items: any[];
    orderByOptions: any[];
    sortOrderOptions: string[];
    isSearchVisible: boolean;
    searchText: string;
    orderBy: string;
    sortOrder: string;
    paging: any;
    loadPagePromise: any;
    filteredItems: any[];
    CoreUserService: any;

    constructor($http, $timeout, $q, $mdToast, OutputMgrService, CoreUserService) {
        'ngInject';
        this.$http = $http;
        this.$timeout = $timeout;
        this.$q = $q;
        this.$mdToast = $mdToast;
        this.OutputMgrService = OutputMgrService;
        this.CoreUserService = CoreUserService;

        this.items = [];
        this.filteredItems = [];
        this.orderByOptions = [
            'name',
            'feedType',
            'created',
            'modified'
        ];
        this.sortOrderOptions = [
            'ASC',
            'DESC'
        ];
        this.isSearchVisible = false;
        this.searchText = '';
        this.orderBy = 'name';
        this.sortOrder = 'ASC';
        this.paging = {
            itemsPerPage: 25,
            selectedPage: 1,
            totalItems: 0
        };
    }

    /**
     * Gets an array of dashboard objects based on the parameters specified.
     * @param {object} params the key / value pairs for the get request
     *          {
     *              _orderby: "ASC" || "DESC",
     *              _sort: "field to sort by",
     *              q: "search text if any"
     *          }
     * @returns promise
     */
    getNewsfeeds(params) {
        this.OutputMgrService.getNewsFeedsByCompanyId().then((items)=>{
            this.items = items;
        });
    }

    /**
     * loads a designated page of dashboard data
     */
    load() {
        return this.loadPagePromise = this.OutputMgrService.getNewsFeedsByCompanyId().then(
            (items)=>{
                    this.items = items;
                this.items.forEach(function(item){
                    item.created = item.createdBy.firstName + ' ' + item.createdBy.lastName;
                    if(item.settings.autoIncludeDocs){
                        item.feedType = 'Automated';
                    } else {
                        item.feedType = 'Manual';
                    }
                });
                this.filteredItems = this.items;
                this.paging.selectedPage = 1;
                this.paging.totalItems = this.items.length;

            },
            (response) => {
            // Handle Failure Response
            }
        );
    }

    getNewsfeedPermissions(){
        return this.CoreUserService.hasPermissions();
    }

    deleteNewsfeed(newsfeed){
        return this.OutputMgrService.deleteOutput(newsfeed).then((items) => {
            this.load();
        })
    }

    clear(){
        this.items = [];
        this.filteredItems = [];
        this.isSearchVisible = false;
        this.searchText = '';
        this.orderBy = 'name';
        this.sortOrder = 'DESC';
        this.paging = {
            itemsPerPage: 25,
            selectedPage: 1,
            totalItems: 0
        };

    }


    /**
     *
     * @param searchText
     * @return {any}
     */
    filterNewsfeeds(searchText) {
        let items = this.items;
        if(searchText && items) {
            this.filteredItems = items.filter((item) => {
                return item.name && item.name.toLowerCase().indexOf(searchText.toLowerCase()) != -1
                    || item.type && item.type.toLowerCase().indexOf(searchText.toLowerCase()) != -1
                    || item.created && item.created.toLowerCase().indexOf(searchText.toLowerCase()) != -1;
            })
        } else {
            this.filteredItems = items;
        }

        this.updatePaging();
    }

    /**
     * Updates the paging data to match the current filtered item set
     */
    updatePaging(){
        this.paging.selectedPage = 1;
        this.paging.totalItems = this.filteredItems.length;
    }

}

export default NewsfeedsStateService;



/** WEBPACK FOOTER **
 ** ./apps-ts/outputs/src/app/newsfeeds/newsfeeds-state.service.ts
 **/